module.exports = __webpack_public_path__ + "static/media/footer-map.30bfc70e.png";